function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r)
    i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;
else {
    var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); };
    o("next", 0), o("throw", 1), o("return", 2);
} }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import axios from 'axios';
import axiosRetry from 'axios-retry';
import { handleErrorModal } from '../../components/Toast';
import Cookies from 'js-cookie';
var statusArr = [403, 500];
var errorCode = ['RequestTimeout', 'InternalError', 'CoreAPIUnavailable', 'CloudIntegrationError'];
export var api = axios.create({
    withCredentials: true,
    baseURL: process.env.REACT_APP_API_URL
});
// Axios retry config
axiosRetry(api, {
    retries: 3,
    retryDelay: axiosRetry.exponentialDelay,
    retryCondition: function retryCondition(error) {
        var _error$response, _error$response2;
        return statusArr.includes((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) && errorCode.includes((_error$response2 = error.response) === null || _error$response2 === void 0 || (_error$response2 = _error$response2.data) === null || _error$response2 === void 0 || (_error$response2 = _error$response2.errors) === null || _error$response2 === void 0 ? void 0 : _error$response2.errorCode);
    }
});
// Add token to request headers
api.interceptors.request.use(function (config) {
    var token = Cookies.get('access_token');
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
});
/** -------------------------------
 * Token Refresh with Request Queue
 ---------------------------------- */
var isRefreshing = false;
var failedQueue = [];
var processQueue = function processQueue(error) {
    var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    failedQueue.forEach(function (prom) {
        if (error) {
            prom.reject(error);
        }
        else {
            prom.resolve(token !== null && token !== void 0 ? token : '');
        }
    });
    failedQueue = [];
};
var refreshToken = /*#__PURE__*/ function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
        var refreshToken, response, _t;
        return _regenerator().w(function (_context) {
            while (1)
                switch (_context.p = _context.n) {
                    case 0:
                        refreshToken = Cookies.get('refresh_token');
                        if (refreshToken) {
                            _context.n = 1;
                            break;
                        }
                        return _context.a(2, null);
                    case 1:
                        _context.p = 1;
                        _context.n = 2;
                        return axios.get("".concat(process.env.REACT_APP_API_URL, "/authentication/token/refresh"), {
                            headers: {
                                refreshtoken: refreshToken
                            },
                            withCredentials: true
                        });
                    case 2:
                        response = _context.v;
                        return _context.a(2, response === null || response === void 0 ? void 0 : response.data);
                    case 3:
                        _context.p = 3;
                        _t = _context.v;
                        throw _t;
                    case 4:
                        return _context.a(2);
                }
        }, _callee, null, [[1, 3]]);
    }));
    return function refreshToken() {
        return _ref.apply(this, arguments);
    };
}();
var errorHandler = function errorHandler(error) {
    var _axiosError$response;
    var axiosError = error;
    var statusCode = (_axiosError$response = axiosError.response) === null || _axiosError$response === void 0 ? void 0 : _axiosError$response.status;
    if (statusCode && statusCode !== 401) {
        var _axiosError$response$, _axiosError$response2;
        var errorMessage = (_axiosError$response$ = axiosError === null || axiosError === void 0 || (_axiosError$response2 = axiosError.response) === null || _axiosError$response2 === void 0 || (_axiosError$response2 = _axiosError$response2.data) === null || _axiosError$response2 === void 0 || (_axiosError$response2 = _axiosError$response2.errors) === null || _axiosError$response2 === void 0 ? void 0 : _axiosError$response2.description) !== null && _axiosError$response$ !== void 0 ? _axiosError$response$ : 'An error occurred';
        handleErrorModal(true, errorMessage);
        return Promise.reject(new Error(errorMessage));
    }
    else {
        Cookies.remove('access_token');
        Cookies.remove('refresh_token');
        Cookies.remove('user');
        Cookies.remove('ui_trace_id');
        sessionStorage.clear();
    }
    return Promise.reject(new Error('Authentication error'));
};
// Main response interceptor
api.interceptors.response.use(function (response) {
    return response;
}, /*#__PURE__*/ function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2(error) {
        var _error$response3;
        var originalRequest, result, _error, _t2;
        return _regenerator().w(function (_context2) {
            while (1)
                switch (_context2.p = _context2.n) {
                    case 0:
                        originalRequest = error.config;
                        if (!(((_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.status) === 401 && !originalRequest._retry)) {
                            _context2.n = 9;
                            break;
                        }
                        if (isRefreshing) {
                            _context2.n = 8;
                            break;
                        }
                        isRefreshing = true;
                        originalRequest._retry = true;
                        _context2.p = 1;
                        _context2.n = 2;
                        return refreshToken();
                    case 2:
                        result = _context2.v;
                        if (!(result !== null && result !== void 0 && result.accessToken)) {
                            _context2.n = 3;
                            break;
                        }
                        Cookies.set('access_token', result.accessToken, {
                            secure: true,
                            sameSite: 'Strict'
                        });
                        Cookies.set('refresh_token', result.refreshToken, {
                            secure: true,
                            sameSite: 'Strict'
                        });
                        processQueue(null, result.accessToken);
                        originalRequest.headers['Authorization'] = 'Bearer ' + result.accessToken;
                        return _context2.a(2, api(originalRequest));
                    case 3:
                        processQueue(new Error('Token refresh failed'), null);
                        return _context2.a(2, errorHandler(error));
                    case 4:
                        _context2.n = 6;
                        break;
                    case 5:
                        _context2.p = 5;
                        _t2 = _context2.v;
                        _error = _t2 instanceof Error ? _t2 : new Error('Token refresh failed');
                        processQueue(_error, null);
                        return _context2.a(2, errorHandler(_error));
                    case 6:
                        _context2.p = 6;
                        isRefreshing = false;
                        return _context2.f(6);
                    case 7:
                        _context2.n = 9;
                        break;
                    case 8:
                        return _context2.a(2, new Promise(function (_resolve, _reject) {
                            failedQueue.push({
                                resolve: function resolve(token) {
                                    originalRequest.headers['Authorization'] = 'Bearer ' + token;
                                    _resolve(api(originalRequest));
                                },
                                reject: function reject(err) {
                                    errorHandler(err);
                                    _reject(err);
                                }
                            });
                        }));
                    case 9:
                        return _context2.a(2, errorHandler(error));
                }
        }, _callee2, null, [[1, 5, 6, 7]]);
    }));
    return function (_x) {
        return _ref2.apply(this, arguments);
    };
}());
